/**
 * @generated SignedSource<<a16ad927c992f25fe42f8246ec95f32f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TestScopeName$data = {
  readonly class: string | null | undefined;
  readonly package: string | null | undefined;
  readonly suite: string | null | undefined;
  readonly " $fragmentType": "TestScopeName";
};
export type TestScopeName$key = {
  readonly " $data"?: TestScopeName$data;
  readonly " $fragmentSpreads": FragmentRefs<"TestScopeName">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TestScopeName",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "suite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "package",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "class",
      "storageKey": null
    }
  ],
  "type": "TestScope",
  "abstractKey": null
};

(node as any).hash = "250839247f0d527837293ed755354159";

export default node;
